<template>
  <nav class="breadcrumb" aria-label="breadcrumbs">
    <ul>
      <li v-for="(item, index) in titleStack" :key="index">
        <router-link :to="item.to || ''" :class="{ 'is-active': !item.to }">
          {{ item.label }}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "TitleBar",
  props: {
    titleStack: {
      type: Array,
      default: () => []
    }
  }
};
</script>
